import {
  ChangeDetectorRef,
  Directive,
  effect,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { isNotNil } from '@web/utils';

@Directive({
  selector: '[appPrimengButton]',
  standalone: true,
})
export class PrimengButtonDirective {
  private readonly button = inject(Button);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly rounded = input<typeof this.button.rounded>(true);
  public readonly styleClass = input<typeof this.button.styleClass>();
  public readonly text = input<typeof this.button.text>(false);
  public readonly severity = input<typeof this.button.severity>('primary');

  private readonly initialStyleClassList = this.getStyleClassList();

  public constructor() {
    effect(() => this.configureText());
    effect(() => this.configureStyleClass());
    effect(() => this.configureSeverity());
    effect(() => this.configureRounded());
  }

  private getStyleClassList(): string[] {
    return this.button.styleClass?.split(' ') ?? [];
  }

  private configureSeverity(): void {
    this.button.severity = this.severity();
    this.changeDetectorRef.detectChanges();
  }

  private configureText(): void {
    this.button.text = this.text();
    this.changeDetectorRef.detectChanges();
  }

  private configureStyleClass(): void {
    const styles = [
      ...this.initialStyleClassList,
      ...this.getDefaultClassList(),
    ];

    this.button.styleClass = styles.filter(isNotNil).join(' ');
    this.changeDetectorRef.detectChanges();
  }

  private configureRounded(): void {
    const styles = [
      ...this.initialStyleClassList,
      ...this.getDefaultClassList(),
    ];

    if (this.rounded()) {
      styles.push('rounded-sm');
    } else {
      styles.push('rounded-none');
    }

    this.button.styleClass = styles.filter(isNotNil).join(' ');
    this.changeDetectorRef.detectChanges();
  }

  private getDefaultClassList(): string[] {
    return ['px-4'];
  }
}
